import { useState, useEffect } from "react";
import { saveMetalPremiums, subscribeMetalPremiums } from "../services/metalPremiumService";

const DEFAULT_PREMIUMS = { gold: 0, silver: 0, platinum: 0 };

export function useMetalPremiums() {
  const [premiums, setPremiums] = useState(DEFAULT_PREMIUMS);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    const unsub = subscribeMetalPremiums(
      (vals) => { setPremiums(vals); setLoading(false); },
      (err) => { setError(err.message); setLoading(false); }
    );
    return unsub;
  }, []);

  const updatePremiums = async (newPremiums) => {
    setPremiums(newPremiums);
    try {
      await saveMetalPremiums(newPremiums);
    } catch (e) {
      setError(e.message);
      throw e;
    }
  };

  return { premiums, loading, error, updatePremiums };
}
